import actionCreator from '../../createAction';

const createAction = actionCreator('notifications');

export const GET_UNREAD_NOTIFICATIONS = createAction(
  'GET_UNREAD_NOTIFICATIONS',
);
export const NEW_NOTIFICATION_RECEIVED = createAction(
  'NEW_NOTIFICATION_RECEIVED',
);
export const MARK_READ = createAction('MARK_READ');
